import React from 'react';
import { C } from './theme';

/** Definitions shown under the dashboard. Keep in step with engine.ts's header comment. */
const ITEMS = [
  {
    name: 'Occupancy without block dates (net)',
    formula: 'sold ÷ (total nights − blocked nights)',
    note: 'How the sellable inventory performed. Judge pricing on this.'
  },
  {
    name: 'Overall occupancy (gross)',
    formula: 'sold ÷ total nights',
    note: 'How the whole portfolio performed. Owner reporting and yield. Total nights are listed nights only; unlisted nights are outside every denominator.'
  },
  {
    name: 'Block share',
    formula: 'blocked ÷ total nights',
    note: 'Inventory that never reached the market.'
  },
  {
    name: 'Sold nights',
    formula: 'nights of every reservation not canceled or expired',
    note: 'Includes confirmed stays that have not arrived yet, which is what the forward book is made of.'
  },
  {
    name: 'ADR',
    formula: 'revenue ÷ billed sold nights',
    note: 'Revenue is payment items excluding commission, spread evenly over each payment’s own nights, USD converted at the payment’s rate. Sold nights not billed yet are left out rather than counted at zero.'
  },
  {
    name: 'RevPAR',
    formula: 'revenue ÷ total nights',
    note: 'Per listed calendar night, blocked nights included.'
  },
  {
    name: 'Exposure',
    formula: 'Σ blocked night × prevailing rate',
    note: "Rate ladder: the unit's own month, then its type, then the portfolio; then the same calendar month in another year, then all-time averages."
  },
  {
    name: 'Expected loss',
    formula: 'Σ blocked night × rate × expected occupancy',
    note: 'Expected occupancy is a fixed rate (60% by default) or, if switched, the share of sellable nights that unit type actually sold in that month.'
  },
  {
    name: 'On the books at N days',
    formula: 'nights for month M booked on or before (M start − N) ÷ sellable',
    note: "Pace, from each reservation's creation date. A canceled reservation counts between its creation and its cancellation."
  }
];

export function Formulas() {
  return (
    <div className="rounded-lg border bg-white p-4" style={{ borderColor: C.line }}>
      <h2 className="text-sm font-semibold">How each number is calculated</h2>
      <div className="mt-3 grid grid-cols-1 gap-4 md:grid-cols-3">
        {ITEMS.map((i) => (
          <div key={i.name}>
            <p className="text-xs font-semibold">{i.name}</p>
            <p
              className="mt-1 rounded border px-2 py-1.5 text-xs"
              style={{ borderColor: C.line, background: '#FBFCFE' }}
            >
              {i.formula}
            </p>
            <p className="mt-1.5 text-xs" style={{ color: C.muted }}>
              {i.note}
            </p>
          </div>
        ))}
      </div>
      <p className="mt-3 text-xs" style={{ color: C.muted }}>
        Blocked nights are valued night by night at that month&rsquo;s rate, never at a period
        average, so a peak-season block is not diluted by off-season ones. A night counts once, in
        one state only: a sold night wins over a block, because the guest stayed.
      </p>
    </div>
  );
}
